let desktopView = window.matchMedia("(min-width: 700px)").matches;


const recipientForm = document.querySelector("#recipient-form-holder");
const destinationToPutForm = document.querySelector(".product-gift-flex");

if(!desktopView) {
  if(recipientForm && destinationToPutForm) {
   destinationToPutForm.insertAdjacentElement("afterend", recipientForm);
  }
}

if (desktopView) {
  var swiper = new Swiper(".products-slide-thumbs", {
    spaceBetween: 10,
    slidesPerView: 4,
    freeMode: true,
    direction: "vertical",
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    watchSlidesProgress: true,
    grabCursor: true,
    pagination: {
      el: '.swiper-pagination',
      type: 'progressbar'
    },
    on: {
      beforeInit: function () {
        let numOfThumbs = this.wrapperEl.querySelectorAll(".swiper-slide").length;
        numOfThumbs <= 4 && this.wrapperEl.parentNode.classList.add("no-pagination")
      }
   }
  });
} else {
  var swiper = new Swiper(".products-slide-thumbs", {
    spaceBetween: 10,
    slidesPerView: 4,
    centeredSlides: true,
    freeMode: true,
  });
}

const inputsSwatch = document.querySelectorAll(".radio__fieldset--swatches input[data-single-option-selector]");
var initialIndexSwipper = 0;


if(inputsSwatch && inputsSwatch.length) {
  inputsSwatch.forEach( (input, i) => {
    if(input.checked === true) initialIndexSwipper = i;
  })
}

const ModelSizeEl = document.querySelector(".product__images--info-model [data-size]");
let activeSlide;
let ModelSize;

function modelSizeHanlde(ModelSizeEl, ModelSize) {
  if (ModelSizeEl && ModelSize){
      ModelSizeEl.innerHTML = ModelSize
      ModelSizeEl.parentNode.parentNode.style.display = "flex"
  }else{
      ModelSizeEl.parentNode.parentNode.style.display = "none"
      ModelSizeEl.innerHTML = ""
  }
}

var swiper2 = new Swiper(".products-slide-main", {
  spaceBetween: 0,
  initialSlide: initialIndexSwipper,
  speed: 200,
  effect: 'fade',
  navigation: {
    nextEl: ".swiper-button-next-mobile",
    prevEl: ".swiper-button-prev-mobile",
  },
  thumbs: {
    swiper: swiper,
  },

/* Set model size on page load if exists */
  on: {
    init: function () {
      activeSlide = this.slides[this.activeIndex];
      ModelSize = activeSlide.querySelector(".image-wrapper").dataset.modelSize;
      modelSizeHanlde(ModelSizeEl, ModelSize);
    },
  },
  
});

/* Handle model size on slide image change */
swiper2.on("slideChange", function () {
   activeSlide = swiper2.slides[swiper2.activeIndex];
   ModelSize = activeSlide.querySelector(".image-wrapper").dataset.modelSize;
   modelSizeHanlde(ModelSizeEl, ModelSize);
});


/* Handle swatch gift-card PDP template and country selector */

const detailsGiftAmounts = document.querySelectorAll('.detail-gift-amounts');

if(detailsGiftAmounts){
  detailsGiftAmounts.forEach( detail => {
    const detailsGiftAmountsLabels = detail.querySelectorAll('ul > li > label');

    if (detailsGiftAmountsLabels.length) {
      function closeGiftAmountSelect() {
        if(detail.hasAttribute("open")) {
          detail.removeAttribute("open");
        }
      }
      detailsGiftAmountsLabels.forEach( label => {
        label.addEventListener('click', closeGiftAmountSelect);
      });
      document.addEventListener('click', closeGiftAmountSelect);
    }
  });
}

const giftAmountsOptions = document.querySelectorAll("[data-gift-amounts-options] input[type='radio']");
let initialSlide = 0;

if(giftAmountsOptions && giftAmountsOptions.length) {

  giftAmountsOptions.forEach( (option, i) => {

    if(option.checked) initialSlide = i; 

    option.addEventListener('change', e => {
        productsSlideGiftCard && productsSlideGiftCard.slideTo(i);
    })
  })
}

var productsSlideGiftCard = new Swiper(".products-slide-gift-card", {
  spaceBetween: 0,
  speed: 200,
  allowTouchMove: false,
  initialSlide: initialSlide,
  effect: 'fade',
});

/**  PDP SIZE GUIDE  **/

const sizeGuideModal = document.querySelector('[data-size-guide-modal]');
const sizeGuideOpenerBtns = document.querySelectorAll('[data-size-guide]');
const sizeGuideCloseBtn = sizeGuideModal && sizeGuideModal.querySelector('[data-size-guide-close]');
const sizeGuideSwitchers = document.querySelectorAll(".size-guide--switcher a");

if (sizeGuideModal){
  sizeGuideModal.scrollTop = 0;
}

if (sizeGuideOpenerBtns.length) {
  sizeGuideOpenerBtns.forEach( btn => {
    btn.addEventListener("click", e => {
      e.preventDefault();
      sizeGuideOpener();
    });
  });
}

if(sizeGuideCloseBtn) {
  sizeGuideCloseBtn.addEventListener("click", e => {
    e.preventDefault();
    sizeGuideClose();
  });
}

document.addEventListener('keydown', (e) => {
  if (e.key === 'Escape') { 
    const isNotCombinedKey = !(e.ctrlKey || e.altKey || e.shiftKey);
    if (isNotCombinedKey) { 
      sizeGuideClose();
    }
  }
});

function sizeGuideClose() {
  if(sizeGuideModal) {
    sizeGuideModal.classList.remove("is-visible");
    document.body.style.overflowY = "auto";
    sizeGuideModal.scrollTop = 0;
  }
}

function sizeGuideOpener() {
  if(sizeGuideModal) {
    sizeGuideModal.classList.add("is-visible");
    sizeGuideModal.scrollTop = 0;
    document.body.style.overflowY = "hidden";
    sizeGuideAnimations();
  } 
}

function sizeGuideAnimations() {
  const sizeGuideModalContent = sizeGuideModal && sizeGuideModal.querySelector('[data-size-guide-content]');
    if (sizeGuideModalContent) {
      sizeGuideModalContent.style.transitionDelay = `100ms`;
    }
}


if(sizeGuideSwitchers){
  sizeGuideSwitchers.forEach(function(sizeGuideSwitcher, i) {
    sizeGuideSwitcher.addEventListener("click", function(event) {
      
      if (desktopView) {
        sizeGuideSwitchers.forEach( (elm) =>  elm.classList.remove('active')); 
        event.currentTarget.classList.add('active');
      }

      if (this.hash !== "") {
        event.preventDefault();
        var hash = this.hash;
        
        if (desktopView) {
        if(hash !== "#sizes") {
          document.querySelector(hash).scrollIntoView({
            behavior: 'smooth', block: 'start', inline: 'nearest'
          });
          window.location.hash = hash;
        }else{
          sizeGuideModal.scrollTop = 0
        }
        }else{
          document.querySelector(hash).scrollIntoView({
            behavior: 'smooth', block: 'start', inline: 'nearest'
          });
          window.location.hash = hash;

        }

      }

    });
  });
}
